import { render } from "./DtRoutes.vue?vue&type=template&id=5d801895&scoped=true"
import script from "./DtRoutes.vue?vue&type=script&lang=js"
export * from "./DtRoutes.vue?vue&type=script&lang=js"

import "./DtRoutes.vue?vue&type=style&index=0&id=5d801895&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d801895"]])

export default __exports__